import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_TOOL_PREFERENCES from './GetToolPreferences.gql';

const parseResult = (result) => {
  const initialState = {};

  const toolPreferencesResponse = get(result, 'core.getToolPreferences');
  return {
    ...initialState,
    ...toolPreferencesResponse,
  };
};

export const useGetToolPreferencesQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_TOOL_PREFERENCES, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };
  return [parsedResult, queryAction];
};
